import { useState } from 'react';

const useSteps = (totalSteps) => {
    const [current, setCurrent] = useState(0);

    const isLastStep = current === totalSteps - 1;

    const next = () => {
        if (isLastStep) return
        setCurrent((prev) => prev + 1);
    };

    const prev = () => {
        if (current > 0) {
            setCurrent((prev) => prev - 1);
        }
    };

    return {
        current,
        isLastStep,
        next,
        prev,
    };
};

export default useSteps;
